<template>
  <div class="address-display">
    <div class="row">
      <label class="col-sm-4 control-label">{{ field.label }}</label>
      <div class="col-sm-8">
        {{ field.value }}<br/>
        <span class="text-muted">Latitude: {{ field.latitude }}<br/>Longitude: {{ field.longitude }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressDisplay',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddressDisplay.vue?ee117362